import React from "react";
import TextField from "../../../bootstrap/TextField";
import {
  FirstNameAndNid,
  Passenger,
  Select,
  UserContactWrapper,
} from "./singleTravellerInformation.styles";

const SingleTravellerInformation = ({
  values,
  passengerIndex,
  handleChange,
  roundTrip,
}) => {
  return (
    <>
      <Passenger>
        {roundTrip ? (
          <label htmlFor={`rname${passengerIndex ? passengerIndex : ""}`}>
            Passenger {passengerIndex}
          </label>
        ) : (
          <label htmlFor={`name${passengerIndex ? passengerIndex : ""}`}>
            Passenger {passengerIndex}
          </label>
        )}

        {roundTrip ? (
          <UserContactWrapper>
            <FirstNameAndNid>
              <Select
                name={`gender${passengerIndex ? passengerIndex : ""}`}
                id={`gender${passengerIndex ? passengerIndex : ""}`}
                onChange={handleChange}
              >
                <option value="Mr">Mr</option>
                <option value="Ms">Ms</option>
              </Select>
              <TextField
                id={`first${passengerIndex}`}
                name={`first${passengerIndex}`}
                type="text"
                placeholder="Given Name"
                value={values[`first${passengerIndex}`]}
                onChange={handleChange}
                autoComplete="nope"
              />
            </FirstNameAndNid>
          </UserContactWrapper>
        ) : (
          <UserContactWrapper>
            <FirstNameAndNid>
              <Select
                name={`gender${passengerIndex ? passengerIndex : ""}`}
                id={`gender${passengerIndex ? passengerIndex : ""}`}
                onChange={handleChange}
              >
                <option value="Mr">Mr</option>
                <option value="Ms">Ms</option>
              </Select>
              <TextField
                id={`first${passengerIndex}`}
                name={`first${passengerIndex}`}
                type="text"
                placeholder="Given Name"
                value={values[`first${passengerIndex}`]}
                onChange={handleChange}
                autoComplete="nope"
              />
            </FirstNameAndNid>
          </UserContactWrapper>
        )}
      </Passenger>
      {/* end passenger */}
    </>
  );
};

export default SingleTravellerInformation;
